import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  OnInit,
} from '@angular/core';
import { select, Store } from '@ngrx/store';
import {
  PrivacyStateService,
  ScrolledObserver,
  ScrolledState,
} from '@immosky/shared';
import { selectSearchResultCount } from './state/results/search-results/search-results.selectors';
import { map } from 'rxjs/operators';
import { StartupServiceService } from './services/startup-service.service';
import {
  AppParametersService,
  AppState,
  ContractTypeOption,
  Country,
  FilterState,
} from '@immosky/types';
import {
  selectIsLoadingSearchResults,
  selectIsMapVisible,
  setIsLoadingSearchResults,
  setIsMapVisible,
} from '@immosky/object-search-layout';
import {
  selectFilterState,
  setContractTypeFilter,
} from '@immosky/object-search-filter';
import { ObjectSearchAppParameters } from './services/object-search-app-parameters.service';
import { selectShowSimilarResults } from './state/results/similar-results/similar-results.selectors';

@Component({
  selector: 'app-object-search',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  private scrolledObserver = new ScrolledObserver();

  allowedToDisplayMap = false;
  isLoading$ = this.store.pipe(select(selectIsLoadingSearchResults));
  isMapVisible$ = this.store.pipe(select(selectIsMapVisible));
  hasResults$ = this.store.pipe(
    select(selectSearchResultCount),
    map((count) => count > 0)
  );
  showSimilarObjects$ = this.store.pipe(select(selectShowSimilarResults));

  scrolledState!: ScrolledState;
  filterState!: FilterState;

  countries: Country[] = [];

  constructor(
    private elRef: ElementRef,
    private cdRef: ChangeDetectorRef,
    private store: Store<AppState>,
    private appParametersService: AppParametersService<ObjectSearchAppParameters>,
    private startupService: StartupServiceService,
    private privacyStateService: PrivacyStateService
  ) {
    this.appParametersService.getAppParametersFromDOM(
      this.elRef.nativeElement.dataset.parametersId
    );
    this.startupService.start();

    this.store
      .pipe(select(selectFilterState))
      .subscribe((filterState: FilterState) => {
        this.filterState = filterState;
      });

    this.store.dispatch(
      setIsLoadingSearchResults({
        isLoading: true,
      })
    );

    this.privacyStateService.canLoadMap.subscribe((isAllowed: boolean) => {
      this.allowedToDisplayMap = isAllowed;
      this.cdRef.markForCheck();
    });

    this.countries = this.appParametersService.get().countries || [];
  }

  ngOnInit(): void {
    this.scrolledObserver.scrollState.subscribe(
      (scrollState: ScrolledState) => {
        this.scrolledState = scrollState;
        this.cdRef.markForCheck();
      }
    );
  }

  onContractTypeChange(filter: ContractTypeOption) {
    this.store.dispatch(
      setContractTypeFilter({
        filter,
      })
    );
  }

  openMap() {
    this.store.dispatch(
      setIsMapVisible({
        isMapVisible: true,
      })
    );
  }
}
